'use strict';

angular.module('internal.vehicles')
    .controller('InternalVehicle', ['$scope', '$stateParams', 'Vehicles', '$rootScope', '$http', function ($scope, $stateParams, Vehicles, $rootScope, $http) {
        $scope.masterVehicle = $stateParams.vehicle;
        $scope.vehicle = $stateParams.vehicle;
        $scope.vehicleID = $stateParams.id;
        $scope.vehicleLoading = true;

        $scope.setMasterVehicle = function (vehicle) {
            $scope.masterVehicle = vehicle;
            $scope.vehicle = angular.copy($scope.masterVehicle);
        }

        $scope.resetVehicle = function () {
            if ($scope.masterVehicle == null) {
                $scope.masterVehicle = {};
            }
            $scope.vehicle = angular.copy($scope.masterVehicle);
        }

        $scope.getVehicle = function () {
            Vehicles.getByID($stateParams.id).then(function (vehicle) {
                $scope.vehicleLoading = false;
                $scope.setMasterVehicle(vehicle);
            })
        }

        $scope.syncVehicle = function () {
            $http({
                method: 'POST',
                url: $rootScope.internalURL + 'license/controller.cfm?method=cnt_vehicles.bulkPushVehiclesByIDs&triggered=true&vehicleIDs=' + $scope.vehicleID
            })
            .then(function (response) {
                $scope.syncInitiated = true;
            })
            .catch(function (response) {
                // handle error
            });
        }

        if ($stateParams.id != null) {
            $scope.getVehicle();
        }
        else {
            var vehicle = {};
            vehicle.complaints = [];
            vehicle.alerts = [];
            $scope.vehicleLoading = false;
            $scope.setMasterVehicle(vehicle);
        }
    }])
;